import * as overlay0 from "./overlay-0";
import * as overlay1 from "./overlay-1";
import * as overlay2 from "./overlay-2";
import * as overlay3 from "./overlay-3";
import * as overlay4 from "./overlay-4";
import * as overlay5 from "./overlay-5";
import * as overlay6 from "./overlay-6";
import * as overlay7 from "./overlay-7";
import * as overlay8 from "./overlay-8";
import * as overlay9 from "./overlay-9";
import * as overlay10 from "./overlay-10";
import * as overlay11 from "./overlay-11";
import * as overlay12 from "./overlay-12";
import * as overlay13 from "./overlay-13";
import * as overlay14 from "./overlay-14";
import * as overlay15 from "./overlay-15";
import * as overlay16 from "./overlay-16";
import * as overlay17 from "./overlay-17";
import * as overlay18 from "./overlay-18";
import * as overlay19 from "./overlay-19";

import * as infobox0 from "./infobox-0";
import * as infobox1 from "./infobox-1";
import * as infobox2 from "./infobox-2";
import * as infobox3 from "./infobox-3";
import * as infobox4 from "./infobox-4";
import * as infobox5 from "./infobox-5";
import * as infobox6 from "./infobox-6";
import * as infobox7 from "./infobox-7";
import * as infobox8 from "./infobox-8";
import * as infobox9 from "./infobox-9";
import * as infobox10 from "./infobox-10";
import * as infobox11 from "./infobox-11";
import * as infobox12 from "./infobox-12";
import * as infobox13 from "./infobox-13";
import * as infobox14 from "./infobox-14";
import * as infobox15 from "./infobox-15";
import * as infobox16 from "./infobox-16";
import * as infobox17 from "./infobox-17";
import * as infobox18 from "./infobox-18";
import * as infobox19 from "./infobox-19";

const overlays = {
    "0": overlay0,
    "1": overlay1,
    "2": overlay2,
    "3": overlay3,
    "4": overlay4,
    "5": overlay5,
    "6": overlay6,
    "7": overlay7,
    "8": overlay8,
    "9": overlay9,
    "10": overlay10,
    "11": overlay11,
    "12": overlay12,
    "13": overlay13,
    "14": overlay14,
    "15": overlay15,
    "16": overlay16,
    "17": overlay17,
    "18": overlay18,
    "19": overlay19,
};

const infoboxes = {
    "0": infobox0,
    "1": infobox1,
    "2": infobox2,
    "3": infobox3,
    "4": infobox4,
    "5": infobox5,
    "6": infobox6,
    "7": infobox7,
    "8": infobox8,
    "9": infobox9,
    "10": infobox10,
    "11": infobox11,
    "12": infobox12,
    "13": infobox13,
    "14": infobox14,
    "15": infobox15,
    "16": infobox16,
    "17": infobox17,
    "18": infobox18,
    "19": infobox19,
};

export {overlays, infoboxes}
